(() => {
  if (window.monumentFaqUI) return;
  window.monumentFaqUI = true;
  const mobile = matchMedia('(max-width:768px)');
  let sequence = 0;
  const el = (tag, cls, text) => { const node = document.createElement(tag); node.className = cls; if (text) node.textContent = text; return node; };
  function pageBuilderFAQs() {
    document.querySelectorAll('[data-pf-type="Accordion"]').forEach(accordion => {
      if (accordion.closest('.homes__article #main-content .rte')) return;
      const heading = accordion.previousElementSibling;
      if (!heading || !/^faqs?$|frequently\s+asked\s+questions/i.test(heading.textContent.trim())) return;
      const root = el('section', 'product-faq'), layout = el('div', 'product-faq__layout');
      const intro = el('header', 'product-faq__intro'), list = el('div', 'product-faq__list');
      const entries = [...accordion.querySelectorAll('[data-pf-type="Accordion.Content.Wrapper"]')].map(wrapper => ({question: wrapper.querySelector('[data-pf-type="Accordion.Header"] span'), answer: wrapper.querySelector('[data-pf-type="Accordion.Content"]')}));
      if (!entries.length || entries.some(e => !e.question || !e.answer)) return;
      heading.before(root); root.append(layout); layout.append(intro,list);
      intro.append(el('p','product-faq__eyebrow','QUICK ANSWERS'),el('h2','product-faq__title',heading.textContent));
      entries.forEach((entry,i) => {
        const item=el('details','product-faq__item'), summary=el('summary','product-faq__question'), answer=el('div','product-faq__answer');
        summary.append(el('span','product-faq__number',String(i+1).padStart(2,'0')),el('span','product-faq__question-text',entry.question.textContent),el('span','product-faq__toggle'));
        while(entry.answer.firstChild)answer.append(entry.answer.firstChild);
        item.append(summary,answer);list.append(item);
      });
      heading.remove();accordion.remove();
    });
  }
  function init() {
    pageBuilderFAQs();
    document.querySelectorAll('.product-faq').forEach(root => {
      if (root.closest('.homes__article #main-content .rte') || root.dataset.faqReady) return;
      const list = root.querySelector('.product-faq__list'), intro = root.querySelector('.product-faq__intro');
      if (!list || !intro) return;
      root.dataset.faqReady = 'true';
      if (!list.id) list.id = 'MonumentFAQList-' + (++sequence);
      const toggle = el('button', 'monument-faq-mobile-toggle'); toggle.type = 'button';
      toggle.setAttribute('aria-controls', list.id);
      const label = el('span', ''), icon = el('span', '', '+'); icon.setAttribute('aria-hidden', 'true'); toggle.append(label, icon); intro.append(toggle);
      const count = list.querySelectorAll('.product-faq__item').length;
      function update(open) {
        root.dataset.faqCollapsed = String(!open);
        toggle.setAttribute('aria-expanded', String(open));
        label.textContent = open ? 'Hide questions' : (root.classList.contains('kb-wrapper') ? 'Show questions' : 'View all ' + count + ' questions'); icon.textContent = open ? '−' : '+';
      }
      function enterMobile() {
        if (mobile.matches) {
          if (list.contains(document.activeElement)) toggle.focus({ preventScroll: true });
          list.querySelectorAll('details[open]').forEach(d => d.open = false);
          update(false);
        } else update(true);
      }
      toggle.addEventListener('click', () => update(toggle.getAttribute('aria-expanded') !== 'true'));
      mobile.addEventListener('change', enterMobile);
      root.addEventListener('input', e => { if (e.target.matches('#kb-search') && e.target.value.trim()) update(true); });
      root.querySelector('.kb-sidebar')?.addEventListener('click', e => { if (e.target.closest('.kb-category-item,.kb-subcategory-item')) update(true); });
      root.querySelectorAll('.kb-panel').forEach(panel => panel.querySelectorAll('.kb-question').forEach((q, i) => {
        const number = el('span', 'product-faq__number', String(i + 1).padStart(2, '0')); number.setAttribute('aria-hidden', 'true'); q.prepend(number);
      }));
      enterMobile();
    });
    updateRails();
  }
  function updateRails() {
    document.querySelectorAll('.msp-features,.msp-steps,.mg-comparison-v2 .related-grid').forEach(rail => {
      rail.classList.remove('monument-mobile-rail');
      const needsRail=mobile.matches && rail.children.length>1 && rail.getBoundingClientRect().height>window.innerHeight;
      if (needsRail) {
        rail.classList.add('monument-mobile-rail');
        if(!rail.dataset.railTabAdded && !rail.hasAttribute('tabindex')){rail.tabIndex=0;rail.dataset.railTabAdded='true';}
        if(!rail.hasAttribute('aria-label')){rail.setAttribute('aria-label','Swipe or use arrow keys for more cards');rail.dataset.railLabelAdded='true';}
      } else {
        if(rail.dataset.railTabAdded){rail.removeAttribute('tabindex');delete rail.dataset.railTabAdded;}
        if(rail.dataset.railLabelAdded){rail.removeAttribute('aria-label');delete rail.dataset.railLabelAdded;}
      }
    });
  }
  let resizeTimer;
  window.addEventListener('resize',()=>{clearTimeout(resizeTimer);resizeTimer=setTimeout(updateRails,150);});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest('.product-faq');
    if (root?.dataset.faqCollapsed === 'true') root.querySelector('.monument-faq-mobile-toggle')?.click();
  });
  function revealFragment() {
    if (!location.hash) return;
    let target;try { target=document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    const root=target?.closest('.product-faq');
    if(root?.dataset.faqCollapsed==='true' && target.closest('.product-faq__list'))root.querySelector('.monument-faq-mobile-toggle')?.click();
  }
  window.addEventListener('hashchange',revealFragment);
})();
